define 'controller/ProductLinkController', ['jquery'], ($) ->
  class ProductLinkController

    constructor: (@$el) ->
      @$el.on 'click', (e) =>
        if not @_isColorSlider(e) and not @_isSliderArrow(e) and not @_isProductData(e) and not @_isWishlistIcon(e) and not @_isSize(e)
          page =  @$el.data 'page'
          articleNumber = @$el.data 'articlenumber'
          index = @$el.data 'index'
          index += 1
          that = this
          $.ajax({
              url: "/api/datalayer/category/clickEvent?index=#{index}&page=#{page}&articleNumber=#{articleNumber}",
              type: 'GET',
              success: (data) ->
                try
                  dataLayer.push(JSON.parse(decodeURIComponent(escape(atob(data)))));
                catch error
                  dataLayer.push(JSON.parse(atob(data)))
              complete: () ->
                that._goToDetailpage()
            })

    _goToDetailpage: ->
      link = @$el.find('.article__link').attr('href')
      if(window.location.search.substring(1))
        split = window.location.search.substring(1).toString().split("&");
        for param in split
          if(param.startsWith("normed_size"))
            value = decodeURIComponent(param.split("=")[1]);
            if(!value.includes("|"))
              value = value.replace(",", "").replace(".", "");
              while (value.length < 3)
                value = "0"+value;
              link += "&size="+value;
              break;
      if link
        window.location.href = link

    _isColorSlider: (e) =>
      return $(e.target).hasClass('article-color-slider') || $(e.target).closest('.article-color-slider').length > 0

    _isSliderArrow: (e) =>
      return $(e.target).closest("[data-controller-element=article-slider-prev]").length > 0 || $(e.target).is("[data-controller-element=article-slider-prev]") || $(e.target).closest("[data-controller-element=article-slider-next]").length > 0 || $(e.target).hasClass("[data-controller-element=article-slider-next]")

    _isProductData: (e) =>
      return $(e.target).hasClass('article__mkz-info') || $(e.target).closest('.article__mkz-info').length > 0

    _isWishlistIcon: (e) =>
      return $(e.target).is("[data-wishlist=true]") || $(e.target).is("[data-wishlist=false]") || $(e.target).hasClass('icon__wishlist')

    _isSize: (e) =>
      return $(e.target).is('[data-controller-element=product-size]')

    destroy: ->
      @$el.off()